const DOMAIN_SUBDIRECTORY = 'skycore-backend'

export default DOMAIN_SUBDIRECTORY
